module.exports = __webpack_public_path__ + "static/media/halloween10.382e0a03.webp";